// src/context/ScannerContext.js
import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { TextInput, StyleSheet, AppState } from 'react-native';
import { AuthContext } from './AuthContext';

const ScannerContext = createContext({
  refocus: () => {},
});

export const useScanner = () => useContext(ScannerContext);

export function ScannerProvider({ navigationRef, children }) {
  const { userToken } = useContext(AuthContext);
  const inputRef = useRef(null);
  const [buffer, setBuffer] = useState('');

  const refocus = useCallback(() => {
    setTimeout(() => inputRef.current?.focus(), 80);
  }, []);

  useEffect(() => {
    if (userToken === null) return;
    refocus();
    const sub = AppState.addEventListener('change', (state) => {
      if (state === 'active') refocus();
    });
    return () => sub.remove();
  }, [userToken, refocus]);

  // Navigation state değişince (sekme/ekran değişimi) yeniden odakla
  useEffect(() => {
    if (userToken === null) return;
    let unsub;
    const setup = () => {
      if (navigationRef?.isReady?.()) {
        unsub = navigationRef.addListener?.('state', () => {
          refocus();
        });
      } else {
        setTimeout(setup, 150);
      }
    };
    setup();
    return () => unsub?.();
  }, [userToken, navigationRef, refocus]);

  const submit = (raw) => {
    const code = (raw || '').replace(/[\r\n\t]+/g, '').trim();
    setBuffer('');
    console.log('[BT SCANNER] raw:', JSON.stringify(raw), '| temizlenmiş:', JSON.stringify(code), '| uzunluk:', code.length);
    if (code.length < 3) {
      console.log('[BT SCANNER] ATLANDI (uzunluk < 3)');
      return;
    }
    if (!navigationRef?.isReady?.()) return;

    const currentRoute = navigationRef.getCurrentRoute?.();
    if (currentRoute?.name === 'Login') return;

    navigationRef.navigate('MainTabs', {
      screen: 'Ana Sayfa',
      params: { pendingBarcode: code, scanTs: Date.now() },
    });
  };

  return (
    <ScannerContext.Provider value={{ refocus }}>
      {children}
      {userToken !== null && (
        <TextInput
          ref={inputRef}
          value={buffer}
          onChangeText={(t) => {
            if (/[\r\n]/.test(t)) submit(t);
            else setBuffer(t);
          }}
          onSubmitEditing={(e) => submit(e?.nativeEvent?.text ?? buffer)}
          showSoftInputOnFocus={false}
          caretHidden
          submitBehavior="submit"
          autoCorrect={false}
          autoCapitalize="none"
          contextMenuHidden
          style={styles.hidden}
        />
      )}
    </ScannerContext.Provider>
  );
}

const styles = StyleSheet.create({
  hidden: { position: 'absolute', top: -1000, left: -1000, width: 1, height: 1, opacity: 0 },
});
